import React, { useState } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import { translations } from './mock';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Jobs from './components/Jobs';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';
import ApplicationPage from './components/ApplicationPage';
import Timeline from './components/Timeline';

function HomePage({ t, currentLang }) {
  return (
    <>
      <Hero t={t} />
      <About t={t} />
      <Services t={t} />
      <Jobs t={t} currentLang={currentLang} />
      <Testimonials t={t} currentLang={currentLang} />
      <Contact t={t} />
    </>
  );
}

function App() {
  const [currentLang, setCurrentLang] = useState('en');
  const t = translations[currentLang];

  const handleLanguageChange = (lang) => {
    setCurrentLang(lang);
  };

  return (
    <BrowserRouter>
      <div className="App">
        <Toaster position="top-right" richColors />
        <Header t={t} currentLang={currentLang} onLanguageChange={handleLanguageChange} />
        <Routes>
          <Route path="/" element={<HomePage t={t} currentLang={currentLang} />} />
          <Route path="/apply" element={<ApplicationPage t={t} />} />
        </Routes>
        <Footer t={t} />
      </div>
    </BrowserRouter>
  );
}

export default App;
